module.exports = __webpack_public_path__ + "static/img/homes-four.6c10086.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/homes-four.png
// module id = rhbg
// module chunks = 0